@mixin translate($x, $y) {
  -webkit-transform: translate($x, $y);
  -ms-transform: translate($x, $y); // IE9+
  transform: translate($x, $y);
}

/* Overlay loader used by Step1New when vehicle availability is loading */
.overlay_loader {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 60;
  border-radius: 5px;
}

.overlay_loader_inner {
  display: flex;
  align-items: center;
  gap: 12px;
}

.overlay_spinner {
  width: 36px;
  height: 36px;
  border: 4px solid #000;
  border-bottom-color: transparent;
  border-radius: 50%;
  box-sizing: border-box;
  animation: overlay-rotation 1s linear infinite;
}

@keyframes overlay-rotation {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.overlay_message {
  font-family: var(--font-family, 'sofia-pro, sans-serif');
  font-size: 16px;
  color: #000;
}

@mixin transition($transition) {
  -webkit-transition: $transition;
  transition: $transition;
}

@mixin transition-transform($transition) {
  -webkit-transition: transform $transition;
  -moz-transition: transform $transition;
  -o-transition: transform $transition;
  transition: transform $transition;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

:root {
  --form-control-color: #8b8b8b;
  --form-background: #eaeaea;
}

input[type="checkbox"],
input[type="radio"] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: #fff;
  /* Not removed via appearance */
  margin: 0 !important;

  font: inherit;
  color: #8b8b8b;
  width: 1em;
  height: 1em;
  border: 0.09em solid #8b8b8b;
  border-radius: 35%;
  /*transform: translateY(-0.075em);*/

  display: grid;
  place-content: center;
}


input[type="checkbox"]::before,
input[type="radio"]::before {
  content: "";
  width: 0.65em;
  height: 0.65em;
  border-radius: 35%;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--form-control-color);
  /* Windows High Contrast Mode */
  background-color: CanvasText;
}

input[type="checkbox"]:checked::before,
input[type="radio"]:checked::before {
  transform: scale(1);
}

/* Hide third-party floating icons while the vehicle video sheet is open (mobile). */
@media (max-width: 767px) {
  body.scs-vehicle-video-open #Access-Pro-Icon,
  body.scs-vehicle-video-open .rp-micro-app-dummy-icon-container {
    display: none !important;
  }
}

